import { get } from "lodash";
import PropTypes from "prop-types";
import { BiCheck, BiFile } from "react-icons/bi";
import { fill } from "utils/helpers/template";
import { SETUP_COUNTS } from "./setup";

const SINGLE_ITEM_COUNT = 1;

const SetupList = ({ items, setup, labels, withIcon }) => (
  <ul className="onboarding__checklist">
    {items.map((item) => {
      const count = get(setup, SETUP_COUNTS[item]) || 0;
      const text = get(labels, item);
      return (
        <li key={item} className="onboarding__setup-item">
          <span className="onboarding__setup-label">
            {withIcon ? <BiFile size={20} aria-hidden="true" /> : null}
            <span className="onboarding__setup-text">
              <strong>{text.TITLE}</strong>
              <span>
                {count
                  ? fill(
                      get(
                        text,
                        count === SINGLE_ITEM_COUNT
                          ? "COUNT_one"
                          : "COUNT_other",
                      ),
                      { count },
                    )
                  : text.NONE}
              </span>
            </span>
          </span>
          {count ? (
            <span className="onboarding__badge onboarding__badge--done">
              <BiCheck size={14} />
            </span>
          ) : (
            <span className="onboarding__badge onboarding__badge--todo">
              {labels.TODO}
            </span>
          )}
        </li>
      );
    })}
  </ul>
);

SetupList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.string).isRequired,
  setup: PropTypes.object.isRequired,
  labels: PropTypes.object.isRequired,
  withIcon: PropTypes.bool,
};

SetupList.defaultProps = {
  withIcon: false,
};

export default SetupList;
